import api from '~/services/api';

function getGlossario() {
  return api.get('glossario');
}

export { getGlossario };
